import React, { memo, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';

import { List, ListSubheader } from '../../material-ui/List';
import { documentsSort, sortObjByField } from '../../../service/sort';
import { NotificationNavigation } from '../NotificationNavigation/NotificationNavigation';
import { NotificationItems } from '../NotificationItems/NotificationItems';
import { getLibraryNotifications } from '../../../selectors/library';
import { getDocumentsNotifications } from '../../../selectors/documents';
import { getDefectsNotifications } from '../../../selectors/defects';

export const NotificationContent = memo(() => {
    const [selectedIndex, changeSelected] = useState(0);
    const shortView = useMediaQuery('(max-width: 480px)');
    const { documentsWithWarning, defectsWithWarning, libraryWithWarning } = useSelector((state) => {
        const libraryWithWarning = getLibraryNotifications(state) || [];
        const documentsWithWarning = getDocumentsNotifications(state) || [];
        const defectsWithWarning = getDefectsNotifications(state) || [];

        return {
            libraryWithWarning,
            documentsWithWarning,
            defectsWithWarning,
        };
    });

    const items = useMemo(() => {
        if (selectedIndex === 0) {
            return documentsWithWarning.sort(documentsSort).map((item) => ({
                id: item.id,
                primary: `${item.airport} ${item.type}`,
                secondary: item.description,
            }));
        }

        if (selectedIndex === 1) {
            return defectsWithWarning.sort(sortObjByField('name')).map((item) => ({
                id: item.id,
                primary: item.name,
            }));
        }

        return libraryWithWarning.sort(sortObjByField('name')).map((item) => ({
            id: item.id,
            primary: item.name,
        }));
    }, [documentsWithWarning, defectsWithWarning, libraryWithWarning, selectedIndex]);

    return (
        <List disablePadding={true}>
            <ListSubheader disableGutters={true}>
                <NotificationNavigation
                    {...{
                        documentsWithWarning,
                        defectsWithWarning,
                        libraryWithWarning,
                        shortView,
                        selectedIndex,
                    }}
                    onChangeSelected={changeSelected}
                />
            </ListSubheader>
            <NotificationItems items={items} selectedIndex={selectedIndex} />
        </List>
    );
});

NotificationContent.displayName = 'NotificationContent';
